export enum FormatDataType {
	NUMBER = 'number',
	NUMBER_DELIMITER = 'number_delimiter',
	PERCENT = 'percent',
	PERCENT_100 = 'percent_100',
	PERCENT_100_NONE = 'percent_100_none',
	NA = 'n/a'
}